import { render, staticRenderFns } from "./Titulo.vue?vue&type=template&id=220f540d&scoped=true"
import script from "./Titulo.vue?vue&type=script&defer=true&lang=js"
export * from "./Titulo.vue?vue&type=script&defer=true&lang=js"
import style0 from "./Titulo.vue?vue&type=style&index=0&id=220f540d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220f540d",
  null
  
)

export default component.exports